import {Button, Form, Input, message, Modal, Spin} from "antd";
import buttonStyles from "../../components/common/styled/Buttons.module.scss";
import React, {useState} from "react";
import {
    deleteView,
    getSheetURL,
    getViewURL,
} from "../../components/Tableau/TableauViz";
import {Workbook} from "../../types/Storyboard";
import {apiExportWorkbookViewPdf} from "../../actions/storyboardApi";

const FORM_NAME = "generateEmailForm"

const NovoEmailAttachmentModel = ({workbook, isModalVisible, setIsModalVisible}: {workbook?: Workbook, isModalVisible: boolean, setIsModalVisible(visible:boolean): void}) => {
    const [form] = Form.useForm()
    const [isSending, setSending] = useState(false);

    const handleCancel = () => {
        form.resetFields()
        setIsModalVisible(false)
    }

    const handleOk = async (values: any) => {
        const viewName = 'printing_Sm8PAp'
        try {
            setSending(true)
            const viewURLs: string[] = [
                (await getViewURL(viewName)) + ".pdf",
                getSheetURL(2) + ".pdf"
            ]
            await apiExportWorkbookViewPdf({
                workbookId: workbook?.workbookId!,
                viewURLs: viewURLs,
                toEmail: values.email,
                toName: values.name
            })
            try {
                await deleteView(viewName)
            } catch (e) {
                console.error('Failed to cleanup view. This does adversely affect any functionality')
            }
            message.success(`Email successfully sent to ${values.email}`)
        } catch (e) {
            console.error(e)
            message.error(`Failed to send email to ${values.email}`)
        } finally {
            setIsModalVisible(false)
            setSending(false)
            form.resetFields()
        }
    }

    return <Modal title="Send to:"
               open={isModalVisible}
               onCancel={handleCancel}
               centered
               footer={[
                   <Button className={buttonStyles.greenPrimary}
                           key="send-email"
                           form={FORM_NAME} htmlType="submit"
                           disabled={isSending}
                   >
                       Send
                   </Button>
               ]}
        >
            <Spin tip="Sending..." spinning={isSending}>
                <Form form={form}
                      name={FORM_NAME}
                      autoComplete="off"
                      onFinish={handleOk}
                >
                    <Form.Item name="name" rules={[{required: true},]}>
                        <Input placeholder="Insert name.... Dear XXX"/>
                    </Form.Item>
                    <Form.Item name="email"
                               rules={[{required: true}, {type: 'email', message: 'The email is not valid'}]}>
                        <Input placeholder="Insert email address"/>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
}

export default NovoEmailAttachmentModel;